import React from 'react'

// Custom Components
import Layout from '../components/layout/Layout'
import Hero from '../components/hero/Hero'
import PortfolioList from '../components/portfolios/portfolio_list/PortfolioList'
import NewsletterForm from '../components/newsletter/NewsletterForm'

import { Helmet } from 'react-helmet'
import { Button, Row, Col } from 'react-bootstrap'

import { Link } from 'react-router';

import image_1 from "../assets/images/image_1.jpg"
import FeaturedVideosSection from '../components/youtube/FeaturedVideosSection'
import SupportBrandSection from '../components/referral-links/SupportBrandSection'
import GlossarySection from '../components/glossary/GlossarySection'


export default function Home() {

  return (
    <>
      <Helmet>
        <title>Stocks With Nik — Simple Investing for Beginners | Learning Dividend & Long-Term Investing Together</title>

        <meta
          name="description"
          content="Stocks With Nik helps beginner investors learn long-term investing the simple way. Explore free beginner-friendly portfolios, investing guides, and weekly insights—all written in a clear, learning-out-loud style."
        />

        <meta
          name="keywords"
          content="beginner investing, how to start investing, dividend investing, long term investing, simple portfolios, beginner stock market, ETF investing for beginners"
        />

        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      <Layout content={
        <>
          <Hero />
          <div className='p-2 mb-5 mt-5' style={{ textAlign: "center" }}>
            <h2>Not sure where to start?</h2>
              <p>These portfolios are built specifically for newer investors who want long-term growth without the confusion.
              <br />
              I walk through each one step-by-step so you know why each position is there — and how it helps you build wealth over time.</p>
          </div>

          <div className='p-2 mb-2 mt-5' style={{ textAlign: "center" }}>
            <Row>
              <Col xs="12" md="6">
                <img src={image_1} style={{ width: "100%", height: "400px", maxWidth: "600px", objectFit: "cover", borderRadius: "10px" }} />
              </Col>
              <Col xs="12" md="6">
              <div style={{maxWidth: "500px"}}>
                <h3>Stop Guessing. Start Investing With a Plan That Actually Fits You.</h3>
                <p>Most beginners don’t fail because they pick the wrong stock.
                  They fail because they never build a plan that matches their personality, goals, and risk tolerance.
                  <br />
                  Take the free quiz and get a personalized long-term portfolio built for you.</p>
                <Link to='/quiz'><Button>Build My Portfolio</Button></Link>
                </div>
              </Col>
            </Row>
          </div>

          <div className='p-2 mb-2 mt-5' style={{ textAlign: "center" }}>
            <h2>Free Example Portfolios</h2>
          </div>
          <PortfolioList />
          <GlossarySection />
          <NewsletterForm />
          <FeaturedVideosSection />
          <SupportBrandSection referralLink={"https://join.robinhood.com/dominim1157"} />
        </>
      } />
    </>
  )
}
